const People = [
    {
    id:1,
    nom : "William Blake",
    job : "poète",
    date : "1757 - 1827",
    photo: "/img/12.jpg",
    miniatures:["/img/Heaven.jpg","/img/tyger.png","/img/doors.jpg", "/img/songs.jpg", "/img/marriage.jpeg", "/img/proverbs.png"], 
    texte:`William Blake est la source d'inspiration de plusieurs artistes sur cette page. Ses Proverbes de l'Enfer sont pour moi un bon exemple de sa façon de voir les choses. Il a bousculé la bien-pensance en imaginant une série de proverbes volontairement provocateurs et souvent paradoxaux, une sorte de pseudo sagesse qui n'est pas sans rappeler les écrits bibliques. Esprit bien en avance sur son temps, son questionnement peut aujourd'hui encore être source d'inspiration.`,
    },
    {
    id:2,
    nom : "Daniel Davey",
    job : "chanteur",
    date : "1973 -",
    photo: "/img/14.jpg",
    miniatures: ["/img/principle.jpg", "/img/vempire.jpg", "/img/dusk.jpg", "/img/cruelty.jpg", "/img/dani.jpg", "/img/dani2.jpg"],
    texte:`Dani est surtout connu pour être le chanteur de Cradle of Filth, groupe de metal gothique apparenté à la scène black metal. Cependant, c'est surtout un parolier hors pair. Ses textes sont incroyablement riches en références littéraires et les tournures employées tout comme les métaphores ne sont pas sans rappeler les plus grands auteurs de la littérature. Très influencé par les poètes romantiques, Shakespeare et la littérature gothique en général.`,
    },
    {
    id:3,
    nom : "Charles Baudelaire",
    job : "poète",
    date : "1821 - 1867",
    photo: "/img/2.jpg",
    miniatures:["/img/les_fleurs_du_mal.jpg","/img/les_fleurs_du_mal-2.jpg", "/img/Charles_Baudelaire.jpg", "/img/Charles_Baudelaire-2.jpg", "/img/charles.jpg", "/img/spleendeparis.jpg"],
    texte: `Ma première rencontre avec Baudelaire s'est faite au lycée avec les "Fleurs du Mal", comme beaucoup de personnes je pense. Il a été pour moi la porte d'entrée vers le mouvement Décadent, l'auteur J.K. Huysmans, le graphiste Aubrey Beardsley et bien sûr Poe.`,
    },
    {
    id:4,
    nom : "Jim Morrison",
    job : "poète, chanteur",
    date: "1943 - 1971",
    photo: "/img/3.jpg",
    miniatures : ["/img/the-doors.jpg", "/img/Strange-days.jpg","/img/The_Doors_-_Waiting_for_the_Sun.jpg", "/img/The_Doors_-_The_Soft_Parade.jpg", "/img/The_Doors_-_Morrison_Hotel.jpg", "/img/LA-Woman.jpg"],
    texte:`C'est mon cousin qui m'a fait découvrir les Doors en me faisant écouter "The End" quand je devais avoir aux alentours de 15 ans. Pour moi, les années soixante, musicalement, c'était surtout les mélodies sucrées des Beach Boys. Là, je découvrais pour la première fois, quelque chose de sombre, d'intense et d'inquiétant. Les textes sont extraordinaires et Morrison finira par essayer de mettre de côté sa carrière de rock star pour devenir ce qu'il a toujours voulu être : un poète.`,
    },
    {
    id:5,
    nom : "Oscar Wilde",
    job : "auteur",
    date : "1854 - 1900",
    photo: "/img/4.jpg",
    miniatures:["/img/Dorian-Gray.jpg","/img/quote.jpg", "/img/quote-2.png", "/img/Earnest.jpg", "/img/quote-3.jpg", "/img/quote-4.jpg"],
    texte: `C'est vers 16 ans que j'ai rencontré Oscar Wilde pour la première fois. C'était le "Portrait de Dorian Gray". Provocateur et doué d'un esprit très vif, la simple lecture de ses aphorismes peut faire naître de grands sourires chez la personne la plus blasée du monde. Fin observateur de son temps, sa pensée n'a pas pris une ride.`
    },
    {
    id:6,
    nom : "Victor Hugo",
    job : "auteur, poète",
    date : "1802 - 1885",
    photo:"/img/7.jpg",
    miniatures:["/img/miserables.jpg","/img/Lire.jpg","/img/notre-dame-de-paris.jpg", "/img/Hugo.portrait.jpg", "/img/Hugo.jpg", "/img/verse.png"],
    texte:`J'ai rencontré Victor Hugo vers l'âge de 10 ans en lisant "Les Misérables". Publié en 1862 mais toujours d'actualité, cette histoire d'injustice et de rédemption est fascinante par sa justesse. Si le titre est bien "Les Misérables" on ne tombe jamais dans le misérabilisme. C'est toute une critique de la société que Hugo livre dans cette oeuvre qui distrait et instruit à la fois.`,
    },
    {
    id:7,
    nom : "H. P. Lovecraft",
    job : "auteur",
    date : "1890 - 1937",
    photo:"/img/8.jpg",
    miniatures:["/img/HP-Lovecraft.jpg","/img/Lovecraft_1915.jpg", "/img/Lovecraft.jpg", "/img/cthulhu.jpg", "/img/dagon.jpg", "/img/ward.jpg"],
    texte: `Lovecraft et son panthéon de dieux anciens ont occupé mes lectures adolescentes pendant quelques années du collège au lycée. Je retrouvais son influence dans les textes des groupes que je commençais à découvrir à cette époque, comme Metallica par exemple. La boucle était bouclée. Son univers est fascinant, oppressant à souhait et toujours peuplé de choses indescriptibles qui font travailler l'imagination plus qu'on ne le voudrait.`,
    },
    {
    id:8,
    nom : "Edgar Poe",
    job : "auteur, poète",
    date : "1809 - 1849",
    photo:"/img/9.jpg",
    miniatures:["/img/assassinat.jpg","/img/Raven.jpg", "/img/alone.jpg", "/img/Poe.jpg", "/img/heart.jpg", "/img/EAP.jpg"],
    texte:`Les contes et poèmes de Poe sont fascinants. Ils ne sont jamais situés dans l'espace ni dans le temps et sont du coup intemporels, chacun est libre d'imaginer ce qu'il veut. C'est un univers sombre qui a influencé nombre d'écrivains, de poètes, de réalisateurs et même de groupes musicaux. Il est surtout connu pour "The Raven" mais son oeuvre est loin de se résumer à ce poème épique.`,
    },
    {
    id:9,
    nom : "Arthur Rimbaud",
    job : "poète",
    date : "1854 - 1891",
    photo:"/img/10.jpg",
    miniatures:["/img/coin-de-table.jpg","/img/dormeur.jpg", "/img/Ma-Boheme.jpg", "/img/rimbaud.jpg", "/img/illuminations.jpg", "/img/Le-Mal.jpg"],
    texte: `Mon premier contact avec Rimbaud s'est fait à l'école primaire vers 9 ou 10 ans. Je devais apprendre le poème "Ma Bohème", texte auquel je ne comprenais pas grand chose. Plus tard, au collège, j'ai dû apprendre "Le Dormeur du Val" et enfin "Voyelles". "Aux âmes bien nées la valeur n'attend pas le nombre des années" disait Corneille et cela se vérifie pour Rimbaud dont toute l'oeuvre a été écrite avant ses 20 ans. Une vie sans concession qui a de quoi fasciner quand on le découvre pendant l'adolescence.`,
    },
    {
    id:10,
    nom : "Kurt Cobain",
    job : "chanteur",
    date: "1967 - 1994",
    photo: "/img/5.jpg",
    miniatures:["/img/bleach.jpg","/img/nevermind.jpg", "/img/inutero.jpg", "/img/Nirvana.jpg", "/img/Cobain.jpg", "/img/nirvana.jpeg"],
    texte:`Kurt Cobain est certainement celui qui m'a le plus influencé au cours de mon adolescence. Il était féministe bien avant que ce ne soit à la mode, il détestait les beaufs et il était doué d'une grande sensibilité. Évidemment, tout ceci est arrivé pour moi au bon moment : j'étais en plein début de mon adolescence quand "Nevermind" est arrivé dans les bacs.`,
    },
    {
    id:11,
    nom : "Percy Bysshe Shelley",
    job : "poète",
    date : "1792 - 1822",
    photo: "/img/11.jpg",
    miniatures:["/img/Ozymandias.jpg","/img/Shelley.jpg", "/img/Music.jpg", "/img/Love.jpg", "/img/Anarchy.png", "/img/Shelleys.jpg"],
    texte:`Shelley, comme tous les autres artistes de cette page, a questionné toute sa vie la société dans laquelle il vivait. Il était athée à une époque où ce n'était pas vraiment à la mode, un peu anarchiste et idéaliste. Il a exhorté le peuple à se rebeller contre l'oppression, de la même façon qu'il est devenu athée en refusant l'oppression de la religion. Mais c'est également un poète hors pair qui sait exalter la beauté de la nature. Proche de Lord Byron, il a épousé en seconde noce Mary Shelley, autrice de "Frankenstein".`,
    },
    {
    id:12,
    nom : "Kristoffer Rygg",
    job : "chanteur",
    date : "1976 -",
    photo: "/img/15.jpg",
    miniatures:["/img/Rygg2007.jpg","/img/shadows.jpg", "/img/Bergtatt.jpeg", "/img/Ulver.jpg", "/img/flowers.jpg", "/img/perdition.jpg"],
    texte:`Ce qui est impressionnant chez cet artiste, c'est sa versatilité : chanteur, parolier, musicien, producteur, il sait tout faire. Très inspiré par Blake, Poe, Rimbaud ses paroles sont imprégnées de mysticisme biblique et de références à la nature humaine.`
    },
    {
    id:13,
    nom: "Georges Brassens",
    job : "chanteur",
    date : "1921 - 1981",
    photo : "/img/16.jpg",
    miniatures:["/img/Brassens.jpg","/img/mourir.jpg", "/img/copains.jpg", "/img/stances.jpg", "/img/georges.jpg", "/img/Georges-Brassens.jpg"],
    texte : `C'est mon père qui m'a initié à la poésie du sétois. J'étais un peu jeune et ce n'était pas vraiment ma tasse de thé mais pourtant on a fait quelques kilomètres en voiture en écoutant des classiques de Brassens. Aujourd'hui, avec le recul, je ne peux nier sa maîtrise de la langue française, sa maîtrise musicale et des idées qui m'ont séduit très tôt. Probablement l'un des derniers poètes de la langue française pour moi.`
    },
    {
    id:14,
    nom : "Emily Brontë",
    job : "auteur",
    date : "1818 - 1848",
    photo: "/img/6.jpg",
    miniatures:["/img/the_bronte_sisters.jpg","/img/emily-bronte.jpg", "/img/Les-Hauts-de-Hurlevent.jpg", "/img/brontequote.jpg", "/img/poems.jpg", "/img/Emily.png"],
    texte: `Emily Brontë est surtout connue pour une chose, son seul et unique roman "Wuthering Heights", "Les Hauts de Hurlevent" en français. J'ai lu ce roman quand j'étais à la fac, en deuxième année d'anglais si ma mémoire est bonne. J'ai lu énormément de romans gothiques pendant mon cursus mais je crois que c'est celui-ci - loin devant les autres - qui est le plus prenant, le plus désespéré et le plus beau. C'est un chef d'oeuvre total. Les diverses adaptations cinématographiques n'ont - pour l'instant - pas réussi à lui rendre justice.`, 
    },
    {
    id:15,
    nom : "Marilyn Manson",
    job : "chanteur",
    date : "1969 -",
    photo: "/img/13.jpg",
    miniatures:["/img/Antichrist-superstar.jpg","/img/mechanical.jpg", "/img/eat-me.jpg", "/img/Chaos.jpg", "/img/Manson.jpg", "/img/smells.jpg"],
    texte:`Difficile de résumer Marilyn Manson en quelques lignes. En tout cas, il est beaucoup plus que ce que les médias nous font voir. Il sait réfléchir et pose sur notre société un regard très critique tout en sachant qu'il en est lui-même le produit. Il sait manier les symboles, la provocation et le blasphème pour s'attirer les foudres de l'Amérique conservatrice qui le blâme de tous les maux possibles - notamment de pousser la jeunesse à la violence. Il est également acteur et peintre.`,
    }
];

export default People;
